export default {
  path: "/",
  name: "Ticket",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/ticketing/ticketsList.vue"),
    },
    {
      path: "customer_tickets",
      name: "Customer Tickets",
      component: () => import("@/views/ticketing/customerTickets.vue"),
    },
    {
      path: "entity_tickets",
      name: "Business Entity Tickets",
      component: () => import("@/views/ticketing/entityTickets.vue"),
    },
    {
      path: "/group-ticketing",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          name: "Group Ticketing",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/ticketing/groupTicketing.vue"),
            },
          ],
        },
      ],
    },
  ],
};
